var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useRef } from 'react';
import { useRecoilState, useResetRecoilState } from 'recoil';
import { manageTeachersState, teacherForm } from './atoms';
import { DefaultModal } from '@/presentation/components';
import { fromCardinal } from '@/presentation/functions/cardinal';
import useCustomToast from '@/presentation/hooks/use-custom-toast';
import TeacherForm from './teacher-form';
const ModalUpdateTeacher = ({ validation, teachersManage }) => {
    var _a;
    const [state, setState] = useRecoilState(manageTeachersState);
    const [formState, setFormState] = useRecoilState(teacherForm);
    const resetFormState = useResetRecoilState(teacherForm);
    const formRef = useRef();
    useEffect(() => {
        setFormState(prev => {
            var _a, _b, _c, _d, _e, _f;
            return (Object.assign(Object.assign({}, prev), { email: (_a = state === null || state === void 0 ? void 0 : state.teacherToUpdate) === null || _a === void 0 ? void 0 : _a.email, firstName: (_b = state === null || state === void 0 ? void 0 : state.teacherToUpdate) === null || _b === void 0 ? void 0 : _b.firstName, lastName: (_c = state === null || state === void 0 ? void 0 : state.teacherToUpdate) === null || _c === void 0 ? void 0 : _c.lastName, grades: (_d = state === null || state === void 0 ? void 0 : state.teacherToUpdate) === null || _d === void 0 ? void 0 : _d.grades, title: { value: (_e = state === null || state === void 0 ? void 0 : state.teacherToUpdate) === null || _e === void 0 ? void 0 : _e.title, label: (_f = state === null || state === void 0 ? void 0 : state.teacherToUpdate) === null || _f === void 0 ? void 0 : _f.title }, isFormInvalid: false }));
        });
    }, [(_a = state === null || state === void 0 ? void 0 : state.teacherToUpdate) === null || _a === void 0 ? void 0 : _a.id]);
    const { showCustomError } = useCustomToast({
        containerId: 'uploadFromCsv'
    });
    const updateTeacher = () => __awaiter(void 0, void 0, void 0, function* () {
        var _b;
        try {
            const gradesString = getGradeFromForm(formRef);
            const grades = gradesString.map(fromCardinal);
            setFormState(prev => (Object.assign(Object.assign({}, prev), { isLoading: true })));
            const res = yield teachersManage.updateTeacher({
                title: formState.title.value,
                firstName: formState.firstName,
                lastName: formState.lastName,
                email: formState.email,
                id: (_b = state === null || state === void 0 ? void 0 : state.teacherToUpdate) === null || _b === void 0 ? void 0 : _b.id,
                grades
            });
            if (res) {
                setState(prev => (Object.assign(Object.assign({}, prev), { isUpdateTeacherModalVisible: false, teacherToUpdate: null, reloadTeachers: !prev.reloadTeachers })));
                setFormState(prev => (Object.assign(Object.assign({}, prev), { isLoading: false })));
            }
            else {
                setState(prev => (Object.assign(Object.assign({}, prev), { isUpdateTeacherModalVisible: false, teacherToUpdate: null })));
                setFormState(prev => (Object.assign(Object.assign({}, prev), { isLoading: false })));
                showCustomError('Error', 'Something went wrong');
            }
        }
        catch (err) {
            setState(prev => (Object.assign(Object.assign({}, prev), { isUpdateTeacherModalVisible: false, teacherToUpdate: null })));
            setFormState(prev => (Object.assign(Object.assign({}, prev), { isLoading: false })));
            showCustomError('Error', err.message);
        }
    });
    const closeModal = () => {
        resetFormState();
        setState(prev => (Object.assign(Object.assign({}, prev), { isUpdateTeacherModalVisible: false, teacherToUpdate: null })));
    };
    const getGradeFromForm = (formRef) => {
        var _a, _b;
        const list = [];
        const elements = formRef.current.elements;
        for (let i = 0; i < elements.length; i++) {
            if ((_b = (_a = elements[i]) === null || _a === void 0 ? void 0 : _a.getAttribute('name')) === null || _b === void 0 ? void 0 : _b.startsWith('check-')) {
                const checkbox = elements[i];
                if (checkbox.checked) {
                    // console.log(checkbox.name);
                    list.push(checkbox.name.replace('check-', ''));
                }
            }
        }
        return list;
    };
    return (React.createElement(DefaultModal, { height: "90", hUnit: "vh", width: "8", wUnit: "vw", overlayCustomStyles: { zIndex: 9999 }, open: state.isUpdateTeacherModalVisible, onClose: closeModal, showClose: true },
        React.createElement(TeacherForm, { title: "Update Teacher", validation: validation, formRef: formRef, onConfirmClick: updateTeacher, emailDisabled: true })));
};
export default ModalUpdateTeacher;
